import { CSSProperties } from 'react';

// Morning Brief hero headline (Figma 13517:97119) — desktop scale. The heavy sans (Archivo) is
// the BASE and the serif (Tinos) is the positional ACCENT run (the 2nd + 2nd-to-last words), the
// same serif/sans pairing the mobile hero uses, so both surfaces read as one design. Both faces
// are 40/-0.8; only the family + weight change between the base and the accent run.
export const BRIEF_HEADLINE: CSSProperties = {
  fontFamily: 'var(--brand-font-display)',
  fontSize: 40,
  fontWeight: 'var(--sym-weight-semibold)',
  lineHeight: '42px',
  letterSpacing: '-0.8px',
  fontFeatureSettings: "'dlig' on",
  color: 'rgb(var(--ink-rgb))',
};

export const BRIEF_HEADLINE_ACCENT: CSSProperties = {
  fontFamily: 'var(--brand-font-serif)',
  fontSize: 40,
  fontWeight: 400,
  lineHeight: '42px',
  letterSpacing: '-0.8px',
  fontFeatureSettings: "'dlig' on",
};

// Mobile hero headline (Figma 13517:97119): the heavy sans (Archivo) is the BASE and the
// serif (Tinos) is the ACCENT run — the same serif/sans pairing as the activate state, so
// both brief states read as one design. Both faces are 32/33 at -0.64; only the family and
// weight change between the base and the `**`-marked accent run.
export const MOBILE_BRIEF_HEADLINE: CSSProperties = {
  fontFamily: 'var(--brand-font-display)',
  fontSize: 32,
  fontWeight: 'var(--sym-weight-semibold)',
  lineHeight: '33px',
  letterSpacing: '-0.64px',
  fontFeatureSettings: "'dlig' on",
  color: 'rgb(var(--ink-rgb))',
};

export const MOBILE_BRIEF_HEADLINE_ACCENT: CSSProperties = {
  fontFamily: 'var(--brand-font-serif)',
  fontSize: 32,
  fontWeight: 400,
  lineHeight: '33px',
  letterSpacing: '-0.64px',
  fontFeatureSettings: "'dlig' on",
};

export const BRIEF_META_TEXT: CSSProperties = {
  fontFamily: 'var(--brand-font-ui)',
  fontSize: 16,
  fontWeight: 'var(--sym-weight-semibold)',
  letterSpacing: '-0.02em',
  color: 'rgba(var(--ink-rgb),0.95)',
};
